import React from 'react';
import BackButtonPage from '../../../../../../components/BackButtonPage';
import '../../../../../../styles/ProjektKezdetei.css'
import { Link } from 'react-router-dom';

function ProjektKezdetei() {
    return (
        <>
            <div className='page-content-container'>
                <img src="/assets/projekt_kezdetei/projektkezd.png" className='projekt-kezdetei-img' alt="Projekt kezdetei" />
                <Link to="/hajoszallag">
                    <img src="/assets/projekt_kezdetei/csepel.png" className='csepel projekt-kezdetei-img' alt="Csepeli hajózás" />
                </Link>
                <img src="/assets/projekt_kezdetei/tudatosan.png" className='projekt-kezdetei-img' alt="Tudatosan szövegrész" />
                <div className="video-container">
                    <iframe 
                        width="560" 
                        height="315" 
                        src="https://www.youtube.com/embed/qPY1xwlIezw" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowFullScreen>
                    </iframe>
                </div>
                <img src="/assets/projekt_kezdetei/ezekutan.png" className='ezekutan projekt-kezdetei-img' alt="Ezekután szövegrész" />
                <BackButtonPage to="/projekt-tortenet" />
            </div>
        </> 
    );
}

export default ProjektKezdetei;